import { DeskPageBodyComponents, DeskPageBodyProps, AjaxResponse } from '@my-types';
import { React, Styled } from '@common/3rd';
import { StyledComponents } from '@styles';
import { PATH, Storage, Envs, Utils, Ajax, Apis } from '@common';
import { PageBody } from '@component';
import { ALL_MENUS } from './page-menus-consts';
/**
 * 桌面页面主体
 */
class DeskPageBody<P extends DeskPageBodyProps, S, C extends DeskPageBodyComponents> extends PageBody<P & any, S & any, C> {
	constructor(props: any) {
		super(props);
		this.state = {
			menuKey: 0,
			keyword: this.props.keyword || '',
			focus: false,
			historyList: [],
			hotWordList: []
		}
	}
	search = async () => {
		try {
			if (this.state.keyword) {
				let path = PATH.DESK2_PRODUCT_SEARCH_RESULT;
				if (this.props?.vendor) {
					path = PATH.DESK2_PRODUCT_SEARCH_RESULT_VENDOR.replace(':vendor', encodeURIComponent(this.props.vendor));
				}
				if (window.location.href.includes('search')) {
					this.getHelpers().getRouter().replaceRedirect(path.replace(':keyword', encodeURIComponent(this.state.keyword.trim())));
				} else {
					this.getHelpers().getRouter().pushRedirect(path.replace(':keyword', encodeURIComponent(this.state.keyword.trim())));
				}
				if (Ajax.isAuthorized()) {
					await this.getHelpers().getAjax().post(Apis.CREATE_SEARCH_HISTORY, { searchWord: this.state.keyword });
				}
			}
		} catch (e) {
			console.log('search event error', e)
		}
	}
	onKeyup = (evt: any) => {
		if (!window.location.href.includes('personal') && evt && (evt.code === 'Enter' || evt.key === 'Enter')) {
			this.search();
		}
	}
	componentWillUnmount() {
		window.removeEventListener("keyup", this.onKeyup);
	}
	async componentDidMount() {
		window.addEventListener('keyup', this.onKeyup);
		try {
			let tenantCode = this.props.tenantCode;
			if (tenantCode) {
				let configRes = await this.getHelpers().getAjax().post(Apis.TENANT_CONFIGURATION_LIST, {
					tenantCode: tenantCode,
					 configType: "SALES_CONFIG", // 不在使用数字"3",使用英文字母组合, 
					 status: 1
				});
				if (configRes?.body?.body && configRes.body.body.length) {
					let configList: { [propName: string]: any }[] = configRes.body.body;
					let hotWordObj = Utils.getConfigFromRes(configList, { detailConfigType: '8' });
					this.setState({ hotWordList: (hotWordObj.list as any[]).map(item => item.image1) });
				}
			}
		} catch (e) {
			console.log('get hot word list error', e)
		}
	}
	protected initComponents(): C {
		const C = super.initComponents();
		return Object.assign(C, {
			Box: Styled(C.Box)`
				padding-bottom: 40px;
				min-height: calc(100vh - 48px - 235px);
				${props => this.renderCSS(props.theme)}
			`,
			LOC: Styled(Styled.div`
				width: 1110px;
				margin: 30px auto;
				font-weight: ${props => props.theme.FONT_WEIGHT_BOLD_LIGHT};
				span:not(:first-child):before {
					content: '>';
					margin-right: 8px;
					margin-left: 8px;
				}
				.link {
					cursor: pointer;
					color: #818498; //${props => props.theme.COLOR_SUCCESS};
					// text-decoration: underline;
					&:hover {
						color: ${props => props.theme.COLOR_SUCCESS};
					}
				}
			`).attrs({
				'data-widget': 'desk-location'
			})``,
			Home: Styled.span`
				cursor: pointer;
				:hover {
					text-decoration: underline;
				}
			`,
			HotWordWrapper: Styled.div`
				line-height: 1; font-size: 12px;position: absolute;bottom: -20px;width: 100%;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;
				> img {margin-right: -5px;}
				> span { display:inline-block;max-width: 144px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;margin-left: 15px; cursor: pointer; color: #818498;}
			`,
			Menu: Styled.div`
				height: 80px;
				padding: 22px 0;
				padding-left: calc(50vw - 555px);
				padding-right: calc(50vw - 555px);
				background: #fff;
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				box-shadow: 0 2px 20px 0 rgba(0,0,0,.05);
				.search-content {
					position: relative;
					> img {
						cursor: pointer;
						position: absolute; top: 7px; right: 10px;
						font-size: 20px;
						color: ${props => props.theme.COLOR_SUCCESS};
					}
					.dropdown {
						position: absolute; left: 0; right: 0; z-index: 2;
						max-height: 70vh;
   						overflow-y: auto;
						background: #fff;
						box-shadow: 0 2px 8px 0 rgba(0,0,0,.1);
						border-radius: 0 0 4px 4px;
						padding: 20px;
						> div {
							display: flex; flex-wrap: wrap;
							p {width: 100%; color: #000;line-height: 1;margin: 10px 0;display:flex;justify-content:space-between;
								> i {display: inline-block;background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAMFBMVEUAAACBg5eChJiAg5eBhJmAhZqAh5eBhJiBhJiAgJ+AhJiBhZiChZeAg5mChJmBhJigX0/TAAAAD3RSTlMAgMBA4DAg79AQn5BgUHD6/QwYAAAAcUlEQVQY02NgYOBc/x8Ifk1gAAHuH0pA0L8BzGFyAJEsChCOApwUUlIvAqoCkYoM/f/h4AcDKuAMYGBlYAhgYANxGL8xnA9g/cOQLwDifGaQN2D+yGBPZ47RBDY1OAcECHF4vyiBgf8FkJAIxJ9+DAwAj+ZBo2HmaJoAAAAASUVORK5CYII=') no-repeat;background-size: contain;width: 18px;height: 18px;}
							}
							> span { font-size: 12px; line-height: 18px; margin: 0 10px 10px 0; color: #818498; background: ${props => props.theme.COLOR_DISABLED_BACKGROUND}; padding: 5px 10px;
									 max-width: 116px; text-overflow: ellipsis;overflow:hidden;white-space: nowrap;cursor: pointer;border-radius:3px;}
							&.hot-word-wrapper {
								> span {max-width: 165px;}
								> span:nth-child(-n + 4) {color: ${props => props.theme.COLOR_PRIMARY}; background:#fce9e7;}
							}
						}
					}
				}
				.menu-content {
					display: flex;
					line-height: 76px;
					font-weight: 400;
					font-size: 18px;
					height: 100%;
					> div {
						white-space: nowrap;
						display: flex;
						align-items: flex-start;
						line-height: 1.5;
						margin-left: 40px;
						cursor: pointer;
						color: #818498;
						&.active {
							color: ${props => props.theme.COLOR_SUCCESS};
							border-bottom: 4px solid ${props => props.theme.COLOR_SUCCESS};
						}
						&:hover {
							color: ${props => props.theme.COLOR_SUCCESS};
						}
					}
				}
			`
		});
	}
	protected reRenderMenu() {
		this.setState({
			menuKey: Math.random()
		})
	}
	protected renderMenus(): JSX.Element | void {
		let menus: any[] = JSON.parse(JSON.stringify(ALL_MENUS));
		menus.forEach(item => item.show = !/企业精选|保险产品/.test(item.label));
		let account = Envs.findAccount();
		let organ = Storage.Last.session().get('organ');
		const entMenu = menus.find(item => item.label.includes('企业精选'));
		const productMenu = menus.find(item => item.label.includes('保险产品'));
		// showMall: false为仅企业精选模式，隐藏企业精选&保险产品
		if (account.hasOwnProperty('showMall') && !account.showMall || !organ ||
		    (account.hasOwnProperty('entProductCount') && !account.entProductCount)) { //  || !Envs.isAuthorized() 2021.12.28 未登录也可查看企业精选
			entMenu.show = false;
		} else if (account.hasOwnProperty('showMall') && account.showMall && organ && account.hasOwnProperty('entProductCount') && account.entProductCount) {
			entMenu.show = true;
		}
		if (account.hasOwnProperty('showMall') && !account.showMall) {
			productMenu.show = false;
		} else if (!account.hasOwnProperty('showMall') || account.showMall) {
			productMenu.show = true;
		}
		let isActive = (path: string) => {
			const locations = this.getLocation();
			let result = false;
			if (window.location.href.includes(PATH.DESK2_HOME) && path !== PATH.DESK2_HOME && !window.location.href.includes('search')) {
				result = window.location.href.includes(path);
			} else if (locations === '首页' && path === PATH.DESK2_HOME) {
				result = true;
			}
			return result
		}
		const C = this.getComponents();
		return <C.Menu>
			<div className="search-content">
				<StyledComponents.INPUT type="text" autoComplete="off" placeholder="搜索您要的保险产品" css={props => `
						border-radius: 40px; padding-left: 20px; min-width: 380px; border: 0; background: #f6f7fb; height: 34px; line-height: 32px;
					`} name="keyword" value={this.state.keyword}
					onChange={evt => this.handleChange(evt)}
					onFocus={async () => {
						this.setState({ focus: true });
						if (Ajax.isAuthorized()) {
							let response: AjaxResponse = await this.getHelpers().getAjax().get(Apis.QUERY_SEARCH_HISTORY);
							if (response?.body?.length) {
								this.setState({ historyList: response.body });
							}
						}
					}}
					onBlur={() => { setTimeout(() => { this.setState({ focus: false }) }, 200) }}
				/>
				<img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAclBMVEUAAAAAyuQAy+QAyeMAwN4Ay+QAy+UAxuMAy+UAyuUAy+QAy+UAyuQAy+UAyuQAyeQAxN4AqscAy+UAyuQAyuQAxd4AxeEAyuUAy+UAyuUAy+QAyuQAyuUAyuMAxuMAyuEAyuEAyuQAy+UAyuUAyeIBy+VipfuAAAAAJXRSTlMAZO4yCPjrI/Ll3NaViF5KEQSvcUMeGd7EwY6Aaj8tKyGsWFc9yf3JFAAAAJ9JREFUGNOVkFcOgzAMQIkTQgYJO5RN1/2vWBHI6E+l+sf2s54lO/kVWfFszTcqBuCC0xoHVI0sxyUp2zubPRzpclU6Rc5NX36OWHYWt9yh0GSAI6h7Ym1OIriB9R+iimBH1yO1vIwghu5IBpYINvL06jowIqfLSLWHqne7ZncHUW8V7oBBrztupFAMhcflAiiVk0mQs6y5b11lrSb5Iz6J8AaQbZwKXQAAAABJRU5ErkJggg=='
					 onClick={() => { this.search() }} />
				{this.state.focus && (this.state.historyList.length || this.state.hotWordList.length) ? <div className="dropdown">
					{this.state.historyList.length ? <div>
						<p>历史记录<i onClick={this.clearHistoryList.bind(this)} /></p>
						{(this.state.historyList as any[]).map((item, index) => <span key={`history_${index}`} onClick={() => {
							this.setState({ keyword: item }, () => { this.search() })
						}}>{item}</span>)}
					</div> : null}
					{this.state.hotWordList.length ? <div className="hot-word-wrapper">
						<p>热门词汇</p>
						{(this.state.hotWordList as any[]).map((item, index) => <span key={`hotword_${index}`} onClick={() => {
							this.setState({ keyword: item }, () => { this.search() })
						}}>{item}</span>)}
					</div> : null}
				</div> : null}
				{this.state.hotWordList.length ? <C.HotWordWrapper>
					<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAMAAABstdySAAAAPFBMVEUAAAD/UED/VkD/VkD/VkD/VkD/V0D/VkD/VUD/VkD/WED/VkD/WED/VUD/V0D/VkD/VUD/VkD/V0D/VkCLH+B7AAAAE3RSTlMAEMCg8O+QgGBQINBAMODfsK9wRGsQBgAAAFFJREFUCNc1jUcSgDAMxDaFNBKa/v9XnAzooJEPntVkH/phc19VCGMeTh6ot2UqGBtd3UwGggIcyPpUhFTUAEGczx6vi6SVVS3mNRhMrZjcI73ssAOl3mjpvAAAAABJRU5ErkJggg==" alt="热门词汇" />
					{(this.state.hotWordList as any[]).map((item, index) => <span key={`hotword_${index}`} onClick={() => {
						this.setState({ keyword: item }, () => { this.search() })
					}}>{item}</span>)}
				</C.HotWordWrapper> : null}
			</div>
			<div className="menu-content">
				{menus.filter(item => item.show).map((item, index) => {
					return <div key={`menu_${this.state.menuKey + index}`} className={isActive(item.path) ? 'active' : ''}
						onClick={() => {
							if (this.props?.vendor) {
								this.getHelpers().getRouter().pushRedirect(item.vendorPath.replace(':vendor', encodeURIComponent(this.props.vendor)));
							} else {
								this.getHelpers().getRouter().pushRedirect(item.path);
							}
						}}>
						{item.label}
					</div>
				})}
			</div>
		</C.Menu>
	}
	protected handleChange(event: React.FormEvent<HTMLInputElement>) {
		const target = event.target as HTMLInputElement;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[target.name]: value});
	}
    protected async clearHistoryList() {
        await this.getHelpers().getAjax().get(Apis.DELETE_SEARCH_HISTORY);
        this.setState({ historyList: [] });
    }
	private getPathByLabel(label: string) {
		let exist = ALL_MENUS.find(item => item.label === label);
		if (this.props?.vendor && exist?.vendorPath) {
			return exist.vendorPath.replace(':vendor', encodeURIComponent(this.props.vendor));
		}
		return exist && exist.path || undefined;
	}
	/**
	 * 描画页面所在位置
	 *
	 * @return {[React.Component]|React.Component}
	 */
	protected renderLocation() {
		const C = this.getComponents();
		const locations = this.getLocation();

		if (locations) {
			return (
				<C.LOC>
					{Utils.toArray(this.getLocation()).map((loc, index) => {
						let path = 'link';
						if (Utils.isString(loc)) {
							path = this.getPathByLabel(loc) as string;
						} else {
							path = this.getPathByLabel(loc.label) as string;
						}
						return <span key={index} className={path ? 'link' : ''} onClick={() => {
							if (path) {
								this.getHelpers().getRouter().pushRedirect(path);
							}
						}}>{loc}</span>;
					})}
				</C.LOC>
			);
		}
	}
	/**
	 * 描画页面主体内容
	 */
	protected renderContent(): JSX.Element | null {
		return null;
	}
	/**
	 * 渲染内容如下:
	 * 1. location
	 * 2. children
	 * 3. content
	 */
	render() {
		const C = this.getComponents();
		const locations = this.getLocation();
		const hideHeaderAndFooter = Envs.isPhone() && ['disclosure/agreement', 'disclosure/statement', 'disclosure/cookie'].some((path: string) => window.location.href.includes(path));
		return (
			<C.Box data-widget="desk-page-body">
				{hideHeaderAndFooter ? <></> : 
					<>{ALL_MENUS.slice(1).find(item => window.location.href.includes(item.path))
						// @ts-ignore
						|| locations === '首页' || locations === '个人中心' || (Array.isArray(locations) && locations.includes('信息披露')) ?
						this.renderMenus() : null
					}
					{this.props.showLocation ? this.renderLocation() : null}</>
				}
				{this.props.children}
				{this.renderContent()}
			</C.Box>
		);
	}
	/**
	 * 获取当前页面的路径. 默认null
	 */
	protected getLocation(): string | string[] | null | undefined | { label: string, onLocClicked?: () => void } | { label: string, onLocClicked?: () => void }[] {
		return this.props.where;
	}
}

export default DeskPageBody;
